import { useState, useEffect } from "react"
import { useRouter } from "next/router"
import Modal from "@common/modal/modal"
import EntitySearchUnit from "../components/entitySearchUnit"
import EntityName from "../components/entityName"
import Svg from "@common/svg"
import { getPathForNewEntity } from "../lib/navigation.js"
import { getCategoryId } from "../lib/filters"
import { useAccountPreferences } from "@common/context/accountPreferencesContext"

// type -> manual , etc
// tabsOverride (to decide tabs on top). Check format in entitySearchUnit
// When string is passed its assumed to be of internal Svg type (from common components) Else expects jsx

export default function EntitySearchModal({
  entityId,
  entityCategoryId, //categoryId for the entity
  isOpen,
  onClose,
  entitySelectMsg,
  icon,
  iconClassName,
  onSelection,
  wrapInLink,
  customTrigger,
  type,
  tabsOverride,
  headerClasses,
  tempEntityName,
  entityUnitMode,
  overrideCategoryId,
  useDefaultReport,
  overrideReportId,
  onReportSelect,
  disabled,
}) {
  const router = useRouter()
  const { accountPreferences } = useAccountPreferences()
  const defaultTimePref = accountPreferences?.storage?.def_time_pref

  const categoryId = getCategoryId()

  const [isModalOpen, setIsModalOpen] = useState(isOpen || false)

  /*
   * TODO - bug registed with tailwind. They'll fix.
   * Causes two loads of dom
   * And error - Uncaught RangeError: Maximum call stack size exceeded.
   */
  // Open on '/' press
  /*
  const slashFunction = useCallback((event) => {
    if(event.keyCode === 191) {
      setIsModalOpen(true) 
    }
  }, [])
  useWindowEvent("keydown", slashFunction, false)
  */

  useEffect(() => {
    setIsModalOpen(isOpen)
  }, [isOpen])

  useEffect(() => {
    if (onClose && isModalOpen == false) onClose()
  }, [isModalOpen])

  const h1Classes =
    " min-w-0 max-w-2xl font-medium text-gray-900 dark:text-gray-300 mr-2 " +
    (headerClasses ? headerClasses : "text-lg md:text-2xl")

  return (
    <div>
      <div
        className="cursor-pointer"
        onClick={() => !disabled && setIsModalOpen(true)}
      >
        {customTrigger ?? (
          <div className="flex min-w-0 items-center cursor-pointer ">
            <h1 className={h1Classes}>
              <EntityName
                entityId={entityId}
                categoryId={entityCategoryId}
                tempEntityName={tempEntityName}
                selectMsg={entitySelectMsg}
              />
            </h1>
            {typeof icon == "string" ? (
              <Svg
                name={icon || "search"}
                classes={"btn-icon " + (iconClassName ? iconClassName : "h-10 w-10")}
              />
            ) : (
              icon
            )}
          </div>
        )}
      </div>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="h-screen w-screen sm:h-screen-5/6 max-w-3xl py-2 px-3 text-left">
          <EntitySearchUnit
            filterBySelectedCategory
            onSelect={handleSelection}
            type={type}
            tabsOverride={tabsOverride}
            useDefaultCategory
            useDefaultReport={useDefaultReport ?? false}
            wrapInLink={wrapInLink}
            mode={entityUnitMode || "fetch"}
            showThumbnail
            overrideCategoryId={overrideCategoryId}
            overrideReportId={overrideReportId}
            onReportSelect={onReportSelect}
          />
        </div>
      </Modal>
    </div>
  )

  // e.g reportId = "sku" or "tag"
  function handleSelection(_categoryId, entityId, entity, reportId) {
    setIsModalOpen(false)
    const newPath = getPathForNewEntity(
      router.asPath,
      router.query,
      entityId,
      _categoryId || categoryId,
      reportId,
      null,
      defaultTimePref
    )
    if (onSelection) {
      onSelection(_categoryId, entityId, entity, reportId)
      return
    } else if (wrapInLink == true) return
    else {
      router.push(newPath)
    }
  }
}
